(function ($) {
  /**
   * jQuery function to prevent default anchor event and take the href * and the title to make a share popup
   *
   * @param  {[object]} e           [Mouse event]
   * @param  {[integer]} intWidth   [Popup width defalut 500]
   * @param  {[integer]} intHeight  [Popup height defalut 400]
   * @param  {[boolean]} blnResize  [Is popup resizeabel default true]
   */
  $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {
    // Prevent default anchor event
    e.preventDefault();

    // Set values for window
    intWidth = intWidth || '500';
    intHeight = intHeight || '400';
    var strResize = blnResize ? 'yes' : 'no';

    // Set title and open popup with focus on it
    var strTitle = typeof this.attr('title') !== 'undefined' ? this.attr('title') : 'Social Share',
      strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
      objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
  };

  /* ================================================== */

  $(document).ready(function ($) {
    $('.sharing__link--trigger').on('click', function (e) {
      $(this).customerPopup(e);
    });
    // DOM ready, take it away

    // select container holding masonry posts
    var $container = $('#article-container-infinite-scroll');

    var itemSelector = '.ht-blog-capsule';
    var masonryOptions = {
      // options...
      itemSelector: itemSelector,
      columnWidth: itemSelector,
      gutter: 40,
    };
    var $articleGrid = $container.imagesLoaded(function () {
      // init Masonry after all images have loaded
      $articleGrid.masonry(masonryOptions);
    });

    // Count number of times infinte scroll is triggered
    var infinite_count = 0;

    // Triggers re-layout on infinite scroll
    // post-load triggers when infinite scroll is called
    $(document.body).on('post-load', function () {
      console.log('post-load!');

      // increment count by 1
      infinite_count = infinite_count + 1;

      // select container holding new posts via infinte scroll
      var $selector = $('#infinite-view-' + infinite_count);

      // find posts within infinite scroll container
      var $elements = $selector.find(itemSelector);

      $elements.css('opacity', '0');

      // append the new posts to the container
      //$container.append($elements).masonry('appended', $elements, true)

      //and on ajax  call append or prepend
      $articleGrid.append($elements).imagesLoaded(function () {
        $articleGrid.masonry('appended', $elements, true);
        $elements.css('opacity', '1');
      });
    });

    $('#category-select').change(function () {
      location.href = $(this).val();
    });

    //Home hidden header functionality
    if (window.location.pathname == '/') {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      window.addEventListener('orientationchange', function () {
        // After orientationchange, add a one-time resize event
        var afterOrientationChange = function () {
          // Post orientation code
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          // Remove the resize event listener after it has executed
          window.removeEventListener('resize', afterOrientationChange);
        };
        window.addEventListener('resize', afterOrientationChange);
      });

      // var homeHeader = $('#masthead');

      // $('#main-navigation').on('show.bs.collapse', function (e) {
      //   homeHeader.addClass('home-show-toggle');
      // });

      // $('#main-navigation').on('hide.bs.collapse', function (e) {
      //   homeHeader.removeClass('home-show-toggle');
      // });

      // window.onscroll = function () {
      //   var currentScrollPos = window.pageYOffset;

      //   if (currentScrollPos > 0) {
      //     homeHeader.addClass('home-show-scroll');
      //   } else {
      //     homeHeader.removeClass('home-show-scroll');
      //   }
      // };
    }

    $('#main-navigation').on('show.bs.collapse', function (e) {
      $('html').addClass('no-scroll');
    });

    $('#main-navigation').on('hide.bs.collapse', function (e) {
      $('html').removeClass('no-scroll');
    });

    $('.subscribe-launch a').click(function (e) {
      e.preventDefault();

      $('.modal__container').fadeIn();
    });

    $('.close__modal').click(function (e) {
      e.preventDefault();

      $('.modal__container').fadeOut();
    });

    $(window).scroll(function () {
      if ($(this).scrollTop() > 50) {
        $('#product-subnav').addClass('shrink');
      } else {
        $('#product-subnav').removeClass('shrink');
      }
    });

    if ($('.jumbotron').length) {
      $('.jumbotron__container').slick({
        appendDots: '.carousel__dots',
        fade: true,
        arrows: false,
        dots: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      });
    }
  });
})(jQuery);



// WEBPACK FOOTER //
// ./js/hautetramp.js